import taskTypes from './taskTypes';
import { EVENT_HANDLERS } from './eventHandlers';

export default { taskTypes, EVENT_HANDLERS };
